module.exports = __webpack_public_path__ + "media/images/pc/top/main_02-ff2e120f3d8e794891164c0e14ebb7ca.jpg";